import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import { Card, Input, Alert } from 'antd';
import BtnSubmit from '../Buttons/BtnSubmit.js';

const { TextArea } = Input;

class Annotation extends Component {
  constructor(props){
    super(props);
    this.state = {
      top: '0px',
      height: '0px',
      comments : {},
      textArea: ''
    }
  }

  componentDidMount(){
    this.scrollTop = this.props.windowState.courseScrollTop;
    this.setState({top: this.calculateTop()});
  }

  componentDidUpdate(prevProps){
    //Needed to update when new pressure point selected
    //as component does not remount on change
    const {key, prompt} = prevProps.data;
    if(prompt !== this.props.data.prompt){
      this.scrollTop = this.props.windowState.courseScrollTop;
      this.setState({top: this.calculateTop()});
    }

    if(!this.state.comments[key]){
      const comments = Object.assign({}, this.state.comments, { [key]: [] });
      this.setState({comments});
    }
  }

  calculateTop(){
    if(!this.annotation)
      return;

    const { nodeRect } = this.props.pressurePoint;
    //header + padding = 60px
    const nodeTop = nodeRect.top - 60;

    //subtract half of height of annotation and add scroll top of div
    let top = nodeTop + this.scrollTop - this.annotation.container.clientHeight/2;

    top = top < 0 ? '0px': top + 'px';

    return top;
  }

  handleAnnotationChange(e){
    this.setState({textArea: e.target.value});
  }

  submit() {
    if(this.state.textArea.length < 1)
      return

    const {data, comments} = this.props;
    const {textArea} = this.state;

    if(!comments[data.key])
      comments[data.key] = [];

    const update = comments[data.key].concat(textArea);
    const payload = Object.assign({}, comments, { [data.key]: update });

    this.props.updateComments(payload, 'save');

    this.setState({ textArea: '' });
  }

  delete(removedAnn){
    const {key} = this.props.data,
          {comments} = this.props;

    const update = comments[key].filter(ann => ann !== removedAnn);
    const payload = Object.assign({}, comments, { [key]: update });

    //add delay for animation
    setTimeout(() => this.props.updateComments(payload, 'delete'), 50);
  }

  renderComments(){
    const {key} = this.props.data;

    if(!this.props.comments[key])
      return

    return this.props.comments[key].map((ann, i) => {
      return (
        <Alert
          key={ann + i}
          className="annotation-comment"
          closable = {true}
          message = {ann}
          onClose = { () => this.delete(ann)}
        />
      );
    });
  }

  render(){
    return (
      <Card
        ref = {(annotation) => {this.annotation = annotation}}
        id="Annotation"
        hoverable={true}
        style={{...this.props.style, top: this.state.top}}
        bodyStyle = {{padding: '8px 16px', hyphens: "auto"}}
        >
        <p>{this.props.data.prompt}</p>
        <TextArea
          placeholder="Type response here"
          id = "annotation-textarea"
          type = "textarea"
          onChange = {(e) => this.handleAnnotationChange(e)}
          value = {this.state.textArea}
          rows = {2}
          autosize={{ minRows: 2, maxRows: 4 }}
        />
      <BtnSubmit id = "annotation-submit" onClick = {() => this.submit()}/>
      <div id="annotation-comments">
        {this.renderComments()}
      </div>
      </Card>
    );
  }
}

function mapStateToProps(state) {
  return {
    comments: state.entries.pressurePoints,
    pressurePoint: state.pressurePoint,
    windowState: state.windowState
  };
}

export default connect(mapStateToProps, actions)(Annotation);



// WEBPACK FOOTER //
// ./src/components/PressurePoint/Annotation.js